<template>
	<div
		class="component c-custom padding-y-24 bp-768:padding-y-48"
		:id="'custom-' + section.id"
		:class="{ dark: section.dark_mode }"
		v-bind:style="{
			'background-image': 'url(' + section.backgroundImage + ') ',
		}"
	>
		<div v-if="section.headline" class="row padding-x-12 ">
			<common-header
				:headline="section.headline"
				:sponsor="section.sponsor"
			/>
		</div>
		<div class="c-custom__content row padding-y-24 padding-x-12">
			<div
				:id="'custom-html-' + section.id"
				class="flex-item-1 c-custom__content-inside"
				v-html="section.text"
			></div>
		</div>
		<div v-if="custom_styles" v-html="custom_styles"></div>
	</div>
</template>

<script>
import SectionBase from './SectionBase';
import CommonHeader from '@/components/common/CommonHeader';
export default {
	extends: SectionBase,
	name: 'SectionCustom',
	components: { CommonHeader },
	data: () => ({}),
	computed: {
		custom_styles() {
			if (this.section.custom_styles) {
				return this.prepend_styles(
					this.section.custom_styles,
					'#custom-' + this.section.id,
				);
			} else {
				return '';
			}
		},
	},
	methods: {
		prepend_styles(styles, prepend) {
			if (!styles) {
				return '';
			}
			if (!prepend) {
				return styles;
			}
			var prepend_parts = prepend.split(',');
			var all_styles = '';
			prepend_parts.forEach((value, index) => {
				var style = prepend_parts[index] + ' ' + styles;
				all_styles += style.replace(
					/([|}][\s$]*)([.#]?-?[_a-zA-Z]+[_a-zA-Z0-9-]*)/g,
					'$1 ' + prepend_parts[index] + ' $2',
				);
			});

			return '<style>' + all_styles + '</style>';
		},
	},
	mounted: function() {
		// v-html implements innerHTML which doesn't execute script tags, this is a workaround
		const containerElement = document.getElementById(
			'custom-html-' + this.section.id,
		);
		const scriptElements = containerElement.querySelectorAll('script');
		Array.from(scriptElements).forEach(scriptElement => {
			const clonedElement = document.createElement('script');
			Array.from(scriptElement.attributes).forEach(attribute => {
				clonedElement.setAttribute(attribute.name, attribute.value);
			});
			clonedElement.text = scriptElement.text;
			scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
		});
	},
};
</script>

<style lang="scss">
.c-custom {
	&__content-inside {
		img {
			max-width: 100%;
			height: auto;
		}
	}
}
</style>

<style scoped lang="scss">
.c-custom {
	color: $main-font-color;
}
</style>
